module.exports = __webpack_public_path__ + "static/media/infoJumbo1.353a6c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/demmeler/images/infoJumbo1.jpg
// module id = 476
// module chunks = 0